import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Col, Modal, ModalHeader, ModalBody, ModalFooter, Nav, NavItem, NavLink, Row, Label, FormFeedback, Form, Input } from 'reactstrap'
import TabsBasic from '../tabs/TabsBasic'
import { camelCaseToNormal } from '../../../utility/Utils'
import { Controller, useForm } from 'react-hook-form'
import AccordionForm from '../accordion/AccordionForm'
import { LiveMode, TestMode,Create_Link, Subscribtion, MyTricksTradeSettings, MyTricksStopTrick, SellMyTrick, AngleLinkForm } from './modalSubComponet'
// import AccordionForm from '../accordion/AccordionForm'
// import Flatpickr from 'react-flatpickr'
// import '@styles/react/libs/flatpickr/flatpickr.scss'
import './modal.scss'
import  PersonalForm from '../../pages/profile/PersonalForm'
import BankDetails from '../../pages/profile/BankDetails'
import KYCDeatils from '../../pages/profile/KYCDetails'
import AadhaarDetails from '../../pages/profile/AadhaarDetails'
import PanDetails from '../../pages/profile/PanDetails'
import ChangePassword from '../../pages/profile/ChangePassword'
import img6 from '@src/assets/images/manual/12.png'
import lonavla from  '@src/assets/images/manual/lonavla.png'
import trade_subscription from '@src/assets/images/manual/trade_subscription.png'
import { ButtonComp, ImgTag } from '../HtmlComp'
import AadharVerification from '../../pages/profile/AadharVerification'



function Modals({selected, setType,type = '',payload, toggle, showModal, message = "You won't be able to this perform this action!" }) {
  const {
    reset,
    control,
    setError,
    setValue,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ })

  const navigate = useNavigate()

  let myBody = ''
  let title = ''
  let modalClass = ''
  let isToggle = true


// useEffect(() => {
// if(type !== "" && myBody !== ""){
//   // debugger
//   switch (type) {

//     case 'AngleLinkForm':    
//     myBody = <Create_Link message={message} toggle={toggle} type={type}/>
//     title = "Angle Account Link"
//     break;
    
//     case 'AngleAccount':    
//     myBody = <Create_Link message={message} toggle={toggle}  />
//     title = "Angle Account"
//     break;

//     case 'RoboActive':    
//     myBody = <Subscribtion message={message} buttonName='Subscribe to Robotrick NOW' toggle={toggle} img={img6} msg='You have not yet subscribed to the Robotrick platform.' />
//     title = "Robo Active"
//     break;

//     case 'TradeSubscription':    
//     myBody = <Subscribtion message={message} buttonName='Subscribe to Trade' toggle={toggle} img={trade_subscription} msg='You have not yet Subscribed for Trading.' note="Please subscribe to the Robotrick platform to trading with us." />
//     title = "Trade Subscription"
//     break;

//     case 'TestMode':    
//     myBody = <TestMode payload={payload} setType={setType} message={message} toggle={toggle} />
//     //title = "Test Mode"
//     break;

//     case 'LiveMode':    
//     myBody = <LiveMode payload={payload} setType={setType} message={message} toggle={toggle} />
//     //title = "Live Mode"
//     break;

//     case 'MyTricksTradeSettings':    
//     myBody = <MyTricksTradeSettings setType={setType} message={message} toggle={toggle} />
//     title = "Tricks Trade Settings"
//     break;
//     case 'MyTricksStopTrick':    
//     myBody = <MyTricksStopTrick setType={setType} message={message} toggle={toggle} payload={payload} />
//     //title = "Stop Trick"
//     break;

//     case 'SellMyTrick':    
//     myBody = <SellMyTrick setType={setType} message={message} toggle={toggle} payload={payload} />
//     //title = "Sell Trick"
//     break;
    
//     case 'Personal':    
//     myBody = <PersonalForm selected={selected} setType={setType} message={message} toggle={toggle} />
//     title = "Personal"
//     break;

//     case 'Bank':    
//     myBody = <BankDetails selected={selected} setType={setType} message={message} toggle={toggle} />
//     title = "Bank"
//     break;

//     case 'KYC':    
//     myBody = <KYCDeatils selected={selected} setType={setType} message={message} toggle={toggle} />
//     title = "KYC"
//     break;

//     case 'AadharVerification':    
//     myBody = <AadharVerification selected={selected} setType={setType} message={message} toggle={toggle} />
//     title = "Aadhar Verification"
//     break;

//     case 'Password':    
//     myBody = <ChangePassword selected={selected} setType={setType} message={message} toggle={toggle} />
//     title = "Password"
//     break;

//     case 'isKYCcompleted':

//     myBody = < >
//       <div className="imgWrapper22222 mb-1">
//         <ImgTag url={img6} />
//       </div>
//       <p >
//         You have not yet provided your bank details or completed the KYC process.
//         Please Complete your KYC before Subscribing to the Robotrick Platform
//       </p>
//       <ButtonComp name={'Go to Profile Settings'} classNames={'primary'} onClick={()=>navigate('profile')} />
//     </>
//     // setModalTitle = "AngleAccount"
//     break;
//     default:
//       myBody='something went wrong'
//       break;
//   }
// }
// }, [type,myBody])

console.log("🚀 ~ file: index.js:139 ~ Modals ~ type:", type)
switch (type) {
  
  case 'AngleLinkForm':    
    myBody = <AngleLinkForm message={message} toggle={toggle} />
    title = "Angle Account Link"
    break;

  case 'AngleAccount':    
  myBody = <Create_Link message={message} toggle={toggle} />
  title = "Angle Account"
  break;

  case 'RoboActive':    
  myBody = <Subscribtion message={message} buttonName='Subscribe to Robotrick NOW' toggle={toggle} img={img6} msg='You have not yet subscribed to the Robotrick platform.' video={true} />
  title = "Robo Active"
  isToggle = false
  break;

  case 'TradeSubscription':    
  myBody = <Subscribtion message={message} buttonName='Subscribe to Trade' toggle={toggle} img={trade_subscription} msg='You have not yet Subscribed for Trading.' note="Please subscribe to the Robotrick platform to trading with us." />
  title = "Trade Subscription"
  break;

  case 'TestMode':    
  myBody = <TestMode payload={payload} setType={setType} message={message} toggle={toggle} />
  //title = "Test Mode"
  break;

  case 'LiveMode':    
  myBody = <LiveMode payload={payload} setType={setType} message={message} toggle={toggle} />
  //title = "Live Mode"
  break;

  case 'MyTricksTradeSettings':    
  myBody = <MyTricksTradeSettings setType={setType} message={message} toggle={toggle} />
  title = "Trick Setting"
  break;
  case 'MyTricksStopTrick':    
  myBody = <MyTricksStopTrick setType={setType} message={message} toggle={toggle} payload={payload} />
  //title = "My Tricks Stop Trick"
  break;

  case 'SellMyTrick':    
  myBody = <SellMyTrick setType={setType} message={message} toggle={toggle} payload={payload} />
  title = "Sell Stock"
  break;
  
  case 'Personal':    
  myBody = <PersonalForm selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "Personal"
  break;

  case 'Bank':    
  myBody = <BankDetails selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "Bank"
  break;

  case 'KYC':    
  myBody = <KYCDeatils selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "KYC"
  break;

  case 'AadhaarVerification':    
  myBody = <AadhaarDetails selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "Aadhaar Verification"
  break;

  case 'PanVerification':    
  myBody = <PanDetails selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "Pan Verification"
  break;

  // case 'AadharVerification':    
  // myBody = <AadharVerification selected={selected} setType={setType} message={message} toggle={toggle} />
  // title = "Aadhar Verification"
  // break;

  case 'Password':    
  myBody = <ChangePassword selected={selected} setType={setType} message={message} toggle={toggle} />
  title = "Password"
  break;

  case 'bumperOffer':    
  myBody = <>
  <div className='text-center bumperoffermodal'>
    <img src={lonavla} className='img-thumbnail' />
    </div>
  </>
  title = null
  modalClass = 'bumperOffer'
  break;

  case 'isKYCcompleted':

  myBody = < >
    <div className="isKYCcompleted mb-1">
      <ImgTag url={img6} />
    </div>
    <p >
      You have not yet provided your bank details or completed the KYC process.
      Please Complete your KYC before Subscribing to the Robotrick Platform
    </p>
    <div className="d-flex justify-content-center">

    <Button color="primary" 
    onClick={toggle}
          // disabled={loader}
         >OK</Button>
    </div>
  </>
  // setModalTitle = "AngleAccount"
  break;
  default:
    myBody='something went wrong'
    break;
}
  return (
    <>
      <Modal backdrop="static" isOpen={showModal} centered className={`modal-lg stocksWarningModal ${type === 'TradeSettings' ? type : ''} ${modalClass ?? ''}`}>
        <ModalHeader className="text-capitalize" toggle={isToggle ? toggle : undefined}  >{title}</ModalHeader>
        <ModalBody className="mx-2">
          {myBody}
        </ModalBody> 
      </Modal>
    </>
  )

}

export default Modals
